import { render, staticRenderFns } from "./GroupPersons.vue?vue&type=template&id=0cbf8f47&"
import script from "./GroupPersons.vue?vue&type=script&lang=ts&"
export * from "./GroupPersons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports